export enum AuthProviderType {
  SUPABASE = 'supabase',
  AUTH0 = 'auth0',
}
